"use client";
import { MouseEventHandler, useCallback } from "react";
import { CtaLink } from "@/components/headToHead/Card";
import { useTabInfo } from "@/utils/hooks/useTabsContext";

export default function TeamStatsLink() {
  const { setActiveTab } = useTabInfo();
  const onClick: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (e) => {
      e.preventDefault();
      if (setActiveTab) {
        setActiveTab("team-stats");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    [setActiveTab]
  );
  return (
    <CtaLink
      label="View all Team Stats"
      href="#"
      onClick={onClick}
      next={false}
      ampModule="team_stats"
    />
  );
}
